import { render, staticRenderFns } from "./AmetrasHexColorPickerTemplate.vue?vue&type=template&id=0613aa5c&"
import script from "./AmetrasHexColorPickerTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasHexColorPickerTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasHexColorPickerTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VColorPicker,VMenu,VTextField})
